/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './app.module';
import * as import2 from '@angular/http';
import * as import3 from '@angular/forms';
import * as import4 from 'ng-inline-svg/lib/inline-svg.module';
import * as import5 from 'angular2-qrcode';
import * as import6 from '@angular/common';
import * as import7 from '@fedelta-pos/data-client/configuration/local-configuration.service';
import * as import8 from '@fedelta-pos/data-client/auth/auth.service';
import * as import9 from '@fedelta-pos/data-client/versioning/version.service';
import * as import10 from '@fedelta-pos/data-client/http/jwt-http-client.service';
import * as import11 from '@fedelta-pos/data-client/i18n/i18n.service';
import * as import12 from 'ng2-translate/src/translate.service';
import * as import13 from '@fedelta-pos/data-client/error/error.service';
import * as import14 from '@fedelta-pos/data-client/error/global-error.handler';
import * as import15 from 'ionic-angular/platform/dom-controller';
import * as import16 from 'ionic-angular/components/app/menu-controller';
import * as import17 from 'ionic-angular/components/app/app';
import * as import18 from 'ionic-angular/gestures/gesture-controller';
import * as import19 from 'ionic-angular/util/ng-module-loader';
import * as import20 from './beacon/beacon-search.model';
import * as import21 from '@ionic-native/device/index';
import * as import22 from './config-support/param-config.service';
import * as import23 from '@angular/platform-browser';
import * as import24 from '@angular/platform-browser/animations';
import * as import25 from 'ng2-translate/index';
import * as import26 from '@fedelta-pos/data-client/auth/auth.module';
import * as import27 from '@fedelta-pos/data-client/http/fedelta-http.module';
import * as import28 from '@fedelta-pos/data-client/configuration/configuration.module';
import * as import29 from '@fedelta-pos/data-client/error/error.module';
import * as import30 from '@fedelta-pos/data-client/validation/validation.module';
import * as import31 from '@fedelta-pos/data-client/i18n/i18n.module';
import * as import32 from 'ionic-angular/module';
import * as import33 from '@fedelta-pos/data-client/resource/resource.module';
import * as import34 from './orchestration/responsive.service';
import * as import35 from './orchestration/navigation.service';
import * as import36 from './orchestration/analytics.service';
import * as import37 from './orchestration/app-entity.model';
import * as import38 from '@fedelta-pos/data-client/logging/server-logging.service';
import * as import39 from './notification/notification.service';
import * as import40 from './orchestration/app-session.service';
import * as import41 from '@fedelta-pos/data-client/configuration/configuration.service';
import * as import42 from './orchestration/app-entry-notification.service';
import * as import43 from './orchestration/session.model';
import * as import44 from './identity/member-summary-entity.model';
import * as import45 from './ordering-context/ordering-context.model';
import * as import46 from './store/store-search.model';
import * as import47 from './schedule/active-schedules-search.model';
import * as import48 from './ui-elements/loading/loading.service';
import * as import49 from './customer-info/customer-details.service';
import * as import50 from './store/geolocate';
import * as import51 from './identity/identity.model';
import * as import52 from './order/pending-orders.service';
import * as import53 from './promo/promo.model';
import * as import54 from './menu/menu-entity.model';
import * as import55 from './menu/sellable-sizes-search.model';
import * as import56 from './menu/menu.model';
import * as import57 from './deal/active-entitlement-validation.service';
import * as import58 from './loyalty-card/loyalty-card-redemption.service';
import * as import59 from './deal/entitlement-entity.model';
import * as import60 from './deal/deal.model';
import * as import61 from './payment/order-payment-details-entity.model';
import * as import62 from './payment/payment.model';
import * as import63 from './order/recent-order.service';
import * as import64 from './order/order-initiation.service';
import * as import65 from './order/order-placement.service';
import * as import66 from './order/order-placement-status.service';
import * as import67 from './order/order-postscript.service';
import * as import68 from './group-order/order-transfer.service';
import * as import69 from './group-order/order-transfer-request-poll.service';
import * as import70 from './order/available-order-times.service';
import * as import71 from './identity/app-user.service';
import * as import72 from './order/order.model';
import * as import73 from './group-order/order-transfer-target-entity.model';
import * as import74 from './group-order/order-transfer-target-search.model';
import * as import75 from './group-order/group-order.model';
import * as import76 from './ordering-context/ordering-context.controller';
import * as import77 from './orchestration/session.controller';
import * as import78 from 'ng-inline-svg/lib/svg-cache.service';
import * as import79 from 'ionic-angular/gestures/gesture-config';
import * as import80 from '@fedelta-pos/data-client/validation/validation.service';
import * as import81 from 'ionic-angular/components/action-sheet/action-sheet-controller';
import * as import82 from 'ionic-angular/components/alert/alert-controller';
import * as import83 from 'ionic-angular/util/events';
import * as import84 from 'ionic-angular/util/form';
import * as import85 from 'ionic-angular/tap-click/haptic';
import * as import86 from 'ionic-angular/platform/keyboard';
import * as import87 from 'ionic-angular/components/loading/loading-controller';
import * as import88 from 'ionic-angular/components/modal/modal-controller';
import * as import89 from 'ionic-angular/components/picker/picker-controller';
import * as import90 from 'ionic-angular/components/popover/popover-controller';
import * as import91 from 'ionic-angular/tap-click/tap-click';
import * as import92 from 'ionic-angular/components/toast/toast-controller';
import * as import93 from 'ionic-angular/transitions/transition-controller';
import * as import94 from '@fedelta-pos/data-client/resource/report/report.service';
import * as import95 from '@ionic-native/app-availability/index';
import * as import96 from '@fedelta-pos/data-client/image/image.service';
import * as import97 from './ui-elements/image/cached-image.service';
import * as import98 from './native-waiter-app.service';
import * as import99 from './payment/card-payment/card-scan.service';
import * as import100 from '@ionic-native/geolocation/index';
import * as import101 from './ordering-context/integrated-delivery-address-validation.service';
import * as import102 from '@ionic-native/splash-screen/index';
import * as import103 from '@ionic-native/status-bar/index';
import * as import104 from './theme/theme.model';
import * as import105 from '../../node_modules/ionic-angular/components/action-sheet/action-sheet-component.ngfactory';
import * as import106 from '../../node_modules/ionic-angular/components/alert/alert-component.ngfactory';
import * as import107 from '../../node_modules/ionic-angular/components/app/app-root.ngfactory';
import * as import108 from '../../node_modules/ionic-angular/components/loading/loading-component.ngfactory';
import * as import109 from '../../node_modules/ionic-angular/components/modal/modal-component.ngfactory';
import * as import110 from '../../node_modules/ionic-angular/components/picker/picker-component.ngfactory';
import * as import111 from '../../node_modules/ionic-angular/components/popover/popover-component.ngfactory';
import * as import112 from '../../node_modules/ionic-angular/components/select/select-popover-component.ngfactory';
import * as import113 from '../../node_modules/ionic-angular/components/toast/toast-component.ngfactory';
import * as import114 from './app.component.ngfactory';
import * as import115 from './payment/adyen-3ds-page/adyen-3ds-page.component.ngfactory';
import * as import116 from './customer-info/age-verification-page/age-verification-page.component.ngfactory';
import * as import117 from './identity/change-password-page/change-password-page.component.ngfactory';
import * as import118 from './ordering-context/customer-notes-edit-page/customer-notes-edit-page.component.ngfactory';
import * as import119 from './customer-info/customer-orders-page/customer-orders-page.component.ngfactory';
import * as import120 from './deal/deal-code-entry-page/deal-code-entry-page.component.ngfactory';
import * as import121 from './deal/deals-page/deals-page.component.ngfactory';
import * as import122 from './start/entry-page/entry-page.component.ngfactory';
import * as import123 from './start/exit-page/exit-page.component.ngfactory';
import * as import124 from './customer-info/feedback-page/feedback-page.component.ngfactory';
import * as import125 from './identity/identification-page/identification-page.component.ngfactory';
import * as import126 from './customer-info/invoice-request-page/invoice-request-page.component.ngfactory';
import * as import127 from './legal/legal-page/legal-page.component.ngfactory';
import * as import128 from './loyalty-card/loyalty-cards-page/loyalty-cards-page.component.ngfactory';
import * as import129 from './customer-info/marketing-entry-page/marketing-entry-page.component.ngfactory';
import * as import130 from './identity/profile-edit-page/profile-edit-page.component.ngfactory';
import * as import131 from './menu/menu-search-page/menu-search-page.component.ngfactory';
import * as import132 from './customer-info/name-edit-page/name-edit-page.component.ngfactory';
import * as import133 from './nav-menu/nav-menu-page.component.ngfactory';
import * as import134 from './inputs/selection-field/options-page/options-page.component.ngfactory';
import * as import135 from './order/order-confirmation-page/order-confirmation-page.component.ngfactory';
import * as import136 from './order/order-details-page/order-details-page.component.ngfactory';
import * as import137 from './ordering-page/ordering-page.component.ngfactory';
import * as import138 from './order/order-item/order-item-options-panel/order-item-combined-extras-edit-page/order-item-combined-extras-edit-page.component.ngfactory';
import * as import139 from './order/order-item/order-item-edit-page/order-item-edit-page.component.ngfactory';
import * as import140 from './order/order-item/order-item-options-panel/order-item-extra-sizes-edit-page/order-item-extra-sizes-edit-page.component.ngfactory';
import * as import141 from './order/order-item/order-item-options-panel/order-item-plg-edit-page/order-item-plg-edit-page.component.ngfactory';
import * as import142 from './ordering-context/order-time-selection-page/order-time-selection-page.component.ngfactory';
import * as import143 from './ordering-context/ordering-context-edit-page/ordering-context-edit-page.component.ngfactory';
import * as import144 from './ordering-context/ordering-context-selection-page/ordering-context-selection-page.component.ngfactory';
import * as import145 from './orchestration/page-container/page-component-container/page-component-container.component.ngfactory';
import * as import146 from './payment/payment-page/payment-page.component.ngfactory';
import * as import147 from './customer-info/phone-edit-page/phone-edit-page.component.ngfactory';
import * as import148 from './promo/promo-page/promo-page.component.ngfactory';
import * as import149 from './ui-elements/qr-code/qr-code-page/qr-code-page.component.ngfactory';
import * as import150 from './ordering-page/reorder-page/reorder-page.component.ngfactory';
import * as import151 from './customer-info/sale-receipt-page/sale-receipt-page.component.ngfactory';
import * as import152 from './group-order/group-order-page/group-order-page.component.ngfactory';
import * as import153 from './notification/simple-dialog-page/simple-dialog-page.component.ngfactory';
import * as import154 from './store/store-details-page/store-details-page.component.ngfactory';
import * as import155 from './payment/tip-selection-page/tip-selection-page.component.ngfactory';
import * as import156 from './payment/wallet-payment/wallet-payment-page/wallet-payment-page.component.ngfactory';
import * as import157 from 'ionic-angular/navigation/url-serializer';
import * as import158 from 'ionic-angular/navigation/deep-linker';
import * as import159 from 'ionic-angular/platform/platform-registry';
import * as import160 from 'ionic-angular/platform/platform';
import * as import161 from 'ionic-angular/config/config';
import * as import162 from 'ionic-angular/util/module-loader';
import * as import163 from 'ionic-angular/config/mode-registry';
import * as import164 from './app.component';
import * as import165 from '@fedelta-pos/data-client/configuration/configuration-service-constants';
import * as import166 from '@fedelta-pos/data-client/versioning/versions';
import * as import167 from 'ng2-translate/src/translate.parser';
import * as import168 from '@angular/animations/browser';
import * as import169 from 'ionic-angular/components/app/app-root';
import * as import170 from '@fedelta-pos/data-client/resource/entity/entity.model';
import * as import171 from '@fedelta-pos/data-client/resource/data.resource.model';
import * as import172 from '@fedelta-pos/data-client/resource/search/search.model';
import * as import173 from '@fedelta-pos/data-client/resource/search/abstract-search.model';
class AppModuleInjector extends import0.ɵNgModuleInjector<import1.AppModule> {
  _HttpModule_0:import2.HttpModule;
  _ɵba_1:import3.ɵba;
  _FormsModule_2:import3.FormsModule;
  _InlineSVGModule_3:import4.InlineSVGModule;
  _QRCodeModule_4:import5.QRCodeModule;
  _CommonModule_5:import6.CommonModule;
  _BrowserXhr_6:import2.BrowserXhr;
  _ResponseOptions_7:import2.BaseResponseOptions;
  _XSRFStrategy_8:any;
  _XHRBackend_9:import2.XHRBackend;
  _RequestOptions_10:import2.BaseRequestOptions;
  _Http_11:any;
  _ConfigurationServiceConstants_12:any;
  _ConfigurationServiceConstants_13:any;
  _ConfigurationServiceConstants_14:any;
  _LocalConfigurationService_15:import7.LocalConfigurationService;
  _ResourceModule_16:any;
  _ResourceModule_17:any;
  _ResourceModule_18:any;
  _ResourceModule_19:any;
  _AuthService_20:any;
  _AuthService_21:import8.AuthService;
  _MODULE_VERSIONS_22:any[];
  _VersionService_23:import9.VersionService;
  _JwtHttpClientService_24:any;
  _JwtHttpClientService_25:import10.JwtHttpClientService;
  _I18nService_26:import11.I18nService;
  _TranslateLoader_27:any;
  _TranslateParser_28:import11.I18nService;
  _MissingTranslationHandler_29:import11.I18nService;
  _TranslateService_30:import12.TranslateService;
  _ErrorService_31:import13.ErrorService;
  _ErrorHandler_32:import14.GlobalErrorHandler;
  _ConfigToken_33:any;
  _PlatformConfigToken_34:any;
  _Platform_35:any;
  _Config_36:any;
  _DomController_37:import15.DomController;
  _MenuController_38:import16.MenuController;
  _App_39:import17.App;
  _GestureController_40:import18.GestureController;
  _DeepLinkConfigToken_41:any;
  _Compiler_42:import0.Compiler;
  _NgModuleLoader_43:import19.NgModuleLoader;
  _ModuleLoader_44:any;
  _BeaconSearchModel_45:import20.BeaconSearchModel;
  _Device_46:import21.Device;
  _ParamConfigService_47:import22.ParamConfigService;
  _APP_INITIALIZER_48:any[];
  _ApplicationInitStatus_49:import0.ApplicationInitStatus;
  _ɵf_50:import0.ɵf;
  _ApplicationRef_51:any;
  _ApplicationModule_52:import0.ApplicationModule;
  _BrowserModule_53:import23.BrowserModule;
  _BrowserAnimationsModule_54:import24.BrowserAnimationsModule;
  _TranslateModule_55:import25.TranslateModule;
  _AuthModule_56:import26.AuthModule;
  _FedeltaHttpModule_57:import27.FedeltaHttpModule;
  _ConfigurationModule_58:import28.ConfigurationModule;
  _ErrorModule_59:import29.ErrorModule;
  _ValidationModule_60:import30.ValidationModule;
  _I18nModule_61:import31.I18nModule;
  _ReactiveFormsModule_62:import3.ReactiveFormsModule;
  _IonicModule_63:import32.IonicModule;
  _ResourceModule_64:import33.ResourceModule;
  _ResponsiveService_65:import34.ResponsiveService;
  _NavigationService_66:import35.NavigationService;
  _AnalyticsService_67:import36.AnalyticsService;
  _AppEntityModel_68:import37.AppEntityModel;
  _ServerLoggingService_69:import38.ServerLoggingService;
  _NotificationService_70:import39.NotificationService;
  _AppSessionService_71:import40.AppSessionService;
  _ConfigurationService_72:import41.ConfigurationService;
  _AppEntryNotificationService_73:import42.AppEntryNotificationService;
  _SessionModel_74:import43.SessionModel;
  _MemberSummaryEntityModel_75:import44.MemberSummaryEntityModel;
  _STORE_SEARCH_FILTER_PROVIDER_76:import45.OrderingContextStoreSearchFilterProvider;
  _StoreSearchModel_77:import46.StoreSearchModel;
  _ActiveSchedulesSearchModel_78:import47.ActiveSchedulesSearchModel;
  _LoadingService_79:import48.LoadingService;
  _CustomerDetailsService_80:import49.CustomerDetailsService;
  _GeolocateService_81:import50.GeolocateService;
  _OrderingContextModel_82:import45.OrderingContextModel;
  _IdentityModel_83:import51.IdentityModel;
  _PendingOrdersService_84:import52.PendingOrdersService;
  _PromoModel_85:import53.PromoModel;
  _MenuEntityModel_86:import54.MenuEntityModel;
  _SellableSizesSearchModel_87:import55.SellableSizesSearchModel;
  _MenuModel_88:import56.MenuModel;
  _ActiveEntitlementValidationService_89:import57.ActiveEntitlementValidationService;
  _LoyaltyCardRedemptionService_90:import58.LoyaltyCardRedemptionService;
  _EntitlementEntityModel_91:import59.EntitlementEntityModel;
  _DealModel_92:import60.DealModel;
  _OrderPaymentDetailsEntityModel_93:import61.OrderPaymentDetailsEntityModel;
  _PaymentModel_94:import62.PaymentModel;
  _RecentOrderService_95:import63.RecentOrderService;
  _OrderInitiationService_96:import64.OrderInitiationService;
  _OrderPlacementService_97:import65.OrderPlacementService;
  _OrderPlacementStatusService_98:import66.OrderPlacementStatusService;
  _OrderPostscriptService_99:import67.OrderPostscriptService;
  _OrderTransferService_100:import68.OrderTransferService;
  _OrderTransferRequestPollService_101:import69.OrderTransferRequestPollService;
  _AvailableOrderTimesService_102:import70.AvailableOrderTimesService;
  _AppUserService_103:import71.AppUserService;
  _OrderModel_104:import72.OrderModel;
  _OrderTransferTargetEntityModel_105:import73.OrderTransferTargetEntityModel;
  _OrderTransferTargetSearchModel_106:import74.OrderTransferTargetSearchModel;
  _GroupOrderModel_107:import75.GroupOrderModel;
  _OrderingContextController_108:import76.OrderingContextController;
  _SessionController_109:import77.SessionController;
  _AppModule_110:import1.AppModule;
  __ɵi_111:import3.ɵi;
  __SVGCacheService_112:import78.SVGCacheService;
  __LOCALE_ID_113:any;
  __NgLocalization_114:import6.NgLocaleLocalization;
  __APP_ID_115:any;
  __IterableDiffers_116:any;
  __KeyValueDiffers_117:any;
  __DomSanitizer_118:import23.ɵe;
  __Sanitizer_119:any;
  __HAMMER_GESTURE_CONFIG_120:import79.IonicGestureConfig;
  __EVENT_MANAGER_PLUGINS_121:any[];
  __EventManager_122:import23.EventManager;
  __ɵDomSharedStylesHost_123:import23.ɵDomSharedStylesHost;
  __ɵDomRendererFactory2_124:import23.ɵDomRendererFactory2;
  __AnimationDriver_125:any;
  __ɵAnimationStyleNormalizer_126:any;
  __ɵAnimationEngine_127:import24.ɵa;
  __RendererFactory2_128:any;
  __ɵSharedStylesHost_129:any;
  __Testability_130:import0.Testability;
  __Meta_131:import23.Meta;
  __Title_132:import23.Title;
  __FormBuilder_133:import3.FormBuilder;
  _ValidationService_134:any;
  __ValidationService_135:import80.ValidationService;
  _AppRootToken_136:any;
  _APP_BASE_HREF_137:any;
  __ActionSheetController_138:import81.ActionSheetController;
  __AlertController_139:import82.AlertController;
  __Events_140:import83.Events;
  __Form_141:import84.Form;
  __Haptic_142:import85.Haptic;
  __Keyboard_143:import86.Keyboard;
  __LoadingController_144:import87.LoadingController;
  __LocationStrategy_145:any;
  __Location_146:import6.Location;
  __UrlSerializer_147:any;
  __DeepLinker_148:any;
  __ModalController_149:import88.ModalController;
  __PickerController_150:import89.PickerController;
  __PopoverController_151:import90.PopoverController;
  __TapClick_152:import91.TapClick;
  __ToastController_153:import92.ToastController;
  __TransitionController_154:import93.TransitionController;
  _ResourceModule_155:any;
  __ReportService_156:import94.ReportService;
  __EntityModel_157:any;
  __DataResourceModel_158:any;
  __SearchModel_159:any;
  __AbstractSearchModel_160:any;
  __AppAvailability_161:import95.AppAvailability;
  __ImageService_162:import96.ImageService;
  __CachedImageService_163:import97.CachedImageService;
  __NativeWaiterAppService_164:import98.NativeWaiterAppService;
  __CardScanService_165:import99.CardScanService;
  __Geolocation_166:import100.Geolocation;
  __IntegratedDeliveryAddressValidationService_167:import101.IntegratedDeliveryAddressValidationService;
  __SplashScreen_168:import102.SplashScreen;
  __StatusBar_169:import103.StatusBar;
  __ThemeModel_170:import104.ThemeModel;
  constructor(parent:import0.Injector) {
    super(parent,[
      import105.ActionSheetCmpNgFactory,
      import106.AlertCmpNgFactory,
      import107.IonicAppNgFactory,
      import108.LoadingCmpNgFactory,
      import109.ModalCmpNgFactory,
      import110.PickerCmpNgFactory,
      import111.PopoverCmpNgFactory,
      import112.SelectPopoverNgFactory,
      import113.ToastCmpNgFactory,
      import114.MyAppNgFactory,
      import115.Adyen3dsPageComponentNgFactory,
      import116.AgeVerificationPageComponentNgFactory,
      import117.ChangePasswordPageComponentNgFactory,
      import118.CustomerNotesEditPageComponentNgFactory,
      import119.CustomerOrdersPageComponentNgFactory,
      import120.DealCodeEntryPageComponentNgFactory,
      import121.DealsPageComponentNgFactory,
      import122.EntryPageComponentNgFactory,
      import123.ExitPageComponentNgFactory,
      import124.FeedbackPageComponentNgFactory,
      import125.IdentificationPageComponentNgFactory,
      import126.InvoiceRequestPageComponentNgFactory,
      import127.LegalPageComponentNgFactory,
      import128.LoyaltyCardsPageComponentNgFactory,
      import129.MarketingEntryPageComponentNgFactory,
      import130.ProfileEditPageComponentNgFactory,
      import131.MenuSearchPageComponentNgFactory,
      import132.NameEditPageComponentNgFactory,
      import133.NavMenuPageComponentNgFactory,
      import134.OptionsPageComponentNgFactory,
      import135.OrderConfirmationPageComponentNgFactory,
      import136.OrderDetailsPageComponentNgFactory,
      import137.OrderingPageComponentNgFactory,
      import138.OrderItemCombinedExtrasEditPageComponentNgFactory,
      import139.OrderItemEditPageComponentNgFactory,
      import140.OrderItemExtraSizesEditPageComponentNgFactory,
      import141.OrderItemPlgEditPageComponentNgFactory,
      import142.OrderTimeSelectionPageComponentNgFactory,
      import143.OrderingContextEditPageComponentNgFactory,
      import144.OrderingContextSelectionPageComponentNgFactory,
      import145.PageComponentContainerComponentNgFactory,
      import146.PaymentPageComponentNgFactory,
      import147.PhoneEditPageComponentNgFactory,
      import148.PromoPageComponentNgFactory,
      import149.QrCodePageComponentNgFactory,
      import150.ReorderPageComponentNgFactory,
      import151.SaleReceiptPageComponentNgFactory,
      import152.GroupOrderPageComponentNgFactory,
      import153.SimpleDialogPageComponentNgFactory,
      import154.StoreDetailsPageComponentNgFactory,
      import155.TipSelectionPageComponentNgFactory,
      import156.WalletPaymentPageComponentNgFactory
    ]
    ,[import107.IonicAppNgFactory]);
  }
  get _ɵi_111():import3.ɵi {
    if ((this.__ɵi_111 == null)) { (this.__ɵi_111 = new import3.ɵi()); }
    return this.__ɵi_111;
  }
  get _SVGCacheService_112():import78.SVGCacheService {
    if ((this.__SVGCacheService_112 == null)) { (this.__SVGCacheService_112 = new import78.SVGCacheService(this.parent.get(import78.InlineSVGConfig,(null as any)),this._Http_11)); }
    return this.__SVGCacheService_112;
  }
  get _LOCALE_ID_113():any {
    if ((this.__LOCALE_ID_113 == null)) { (this.__LOCALE_ID_113 = import0.ɵn(this.parent.get(import0.LOCALE_ID,(null as any)))); }
    return this.__LOCALE_ID_113;
  }
  get _NgLocalization_114():import6.NgLocaleLocalization {
    if ((this.__NgLocalization_114 == null)) { (this.__NgLocalization_114 = new import6.NgLocaleLocalization(this._LOCALE_ID_113)); }
    return this.__NgLocalization_114;
  }
  get _APP_ID_115():any {
    if ((this.__APP_ID_115 == null)) { (this.__APP_ID_115 = import0.ɵg()); }
    return this.__APP_ID_115;
  }
  get _IterableDiffers_116():any {
    if ((this.__IterableDiffers_116 == null)) { (this.__IterableDiffers_116 = import0.ɵl()); }
    return this.__IterableDiffers_116;
  }
  get _KeyValueDiffers_117():any {
    if ((this.__KeyValueDiffers_117 == null)) { (this.__KeyValueDiffers_117 = import0.ɵm()); }
    return this.__KeyValueDiffers_117;
  }
  get _DomSanitizer_118():import23.ɵe {
    if ((this.__DomSanitizer_118 == null)) { (this.__DomSanitizer_118 = new import23.ɵe(this.parent.get(import23.DOCUMENT))); }
    return this.__DomSanitizer_118;
  }
  get _Sanitizer_119():any {
    if ((this.__Sanitizer_119 == null)) { (this.__Sanitizer_119 = this._DomSanitizer_118); }
    return this.__Sanitizer_119;
  }
  get _HAMMER_GESTURE_CONFIG_120():import79.IonicGestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_120 == null)) { (this.__HAMMER_GESTURE_CONFIG_120 = new import79.IonicGestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_120;
  }
  get _EVENT_MANAGER_PLUGINS_121():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_121 == null)) { (this.__EVENT_MANAGER_PLUGINS_121 = [
      new import23.ɵDomEventsPlugin(this.parent.get(import23.DOCUMENT)),
      new import23.ɵKeyEventsPlugin(this.parent.get(import23.DOCUMENT)),
      new import23.ɵHammerGesturesPlugin(this.parent.get(import23.DOCUMENT),this._HAMMER_GESTURE_CONFIG_120)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_121;
  }
  get _EventManager_122():import23.EventManager {
    if ((this.__EventManager_122 == null)) { (this.__EventManager_122 = new import23.EventManager(this._EVENT_MANAGER_PLUGINS_121,this.parent.get(import0.NgZone))); }
    return this.__EventManager_122;
  }
  get _ɵDomSharedStylesHost_123():import23.ɵDomSharedStylesHost {
    if ((this.__ɵDomSharedStylesHost_123 == null)) { (this.__ɵDomSharedStylesHost_123 = new import23.ɵDomSharedStylesHost(this.parent.get(import23.DOCUMENT))); }
    return this.__ɵDomSharedStylesHost_123;
  }
  get _ɵDomRendererFactory2_124():import23.ɵDomRendererFactory2 {
    if ((this.__ɵDomRendererFactory2_124 == null)) { (this.__ɵDomRendererFactory2_124 = new import23.ɵDomRendererFactory2(this._EventManager_122,this._ɵDomSharedStylesHost_123)); }
    return this.__ɵDomRendererFactory2_124;
  }
  get _AnimationDriver_125():any {
    if ((this.__AnimationDriver_125 == null)) { (this.__AnimationDriver_125 = import24.ɵb()); }
    return this.__AnimationDriver_125;
  }
  get _ɵAnimationStyleNormalizer_126():any {
    if ((this.__ɵAnimationStyleNormalizer_126 == null)) { (this.__ɵAnimationStyleNormalizer_126 = import24.ɵc()); }
    return this.__ɵAnimationStyleNormalizer_126;
  }
  get _ɵAnimationEngine_127():import24.ɵa {
    if ((this.__ɵAnimationEngine_127 == null)) { (this.__ɵAnimationEngine_127 = new import24.ɵa(this._AnimationDriver_125,this._ɵAnimationStyleNormalizer_126)); }
    return this.__ɵAnimationEngine_127;
  }
  get _RendererFactory2_128():any {
    if ((this.__RendererFactory2_128 == null)) { (this.__RendererFactory2_128 = import24.ɵd(this._ɵDomRendererFactory2_124,this._ɵAnimationEngine_127,this.parent.get(import0.NgZone))); }
    return this.__RendererFactory2_128;
  }
  get _ɵSharedStylesHost_129():any {
    if ((this.__ɵSharedStylesHost_129 == null)) { (this.__ɵSharedStylesHost_129 = this._ɵDomSharedStylesHost_123); }
    return this.__ɵSharedStylesHost_129;
  }
  get _Testability_130():import0.Testability {
    if ((this.__Testability_130 == null)) { (this.__Testability_130 = new import0.Testability(this.parent.get(import0.NgZone))); }
    return this.__Testability_130;
  }
  get _Meta_131():import23.Meta {
    if ((this.__Meta_131 == null)) { (this.__Meta_131 = new import23.Meta(this.parent.get(import23.DOCUMENT))); }
    return this.__Meta_131;
  }
  get _Title_132():import23.Title {
    if ((this.__Title_132 == null)) { (this.__Title_132 = new import23.Title(this.parent.get(import23.DOCUMENT))); }
    return this.__Title_132;
  }
  get _FormBuilder_133():import3.FormBuilder {
    if ((this.__FormBuilder_133 == null)) { (this.__FormBuilder_133 = new import3.FormBuilder()); }
    return this.__FormBuilder_133;
  }
  get _ValidationService_135():import80.ValidationService {
    if ((this.__ValidationService_135 == null)) { (this.__ValidationService_135 = new import80.ValidationService(this._JwtHttpClientService_25,this._TranslateService_30,this._ValidationService_134,this._ResourceModule_16)); }
    return this.__ValidationService_135;
  }
  get _ActionSheetController_138():import81.ActionSheetController {
    if ((this.__ActionSheetController_138 == null)) { (this.__ActionSheetController_138 = new import81.ActionSheetController(this._App_39,this._Config_36)); }
    return this.__ActionSheetController_138;
  }
  get _AlertController_139():import82.AlertController {
    if ((this.__AlertController_139 == null)) { (this.__AlertController_139 = new import82.AlertController(this._App_39,this._Config_36)); }
    return this.__AlertController_139;
  }
  get _Events_140():import83.Events {
    if ((this.__Events_140 == null)) { (this.__Events_140 = new import83.Events()); }
    return this.__Events_140;
  }
  get _Form_141():import84.Form {
    if ((this.__Form_141 == null)) { (this.__Form_141 = new import84.Form()); }
    return this.__Form_141;
  }
  get _Haptic_142():import85.Haptic {
    if ((this.__Haptic_142 == null)) { (this.__Haptic_142 = new import85.Haptic(this._Platform_35)); }
    return this.__Haptic_142;
  }
  get _Keyboard_143():import86.Keyboard {
    if ((this.__Keyboard_143 == null)) { (this.__Keyboard_143 = new import86.Keyboard(this._Config_36,this._Platform_35,this.parent.get(import0.NgZone),this._DomController_37)); }
    return this.__Keyboard_143;
  }
  get _LoadingController_144():import87.LoadingController {
    if ((this.__LoadingController_144 == null)) { (this.__LoadingController_144 = new import87.LoadingController(this._App_39,this._Config_36)); }
    return this.__LoadingController_144;
  }
  get _LocationStrategy_145():any {
    if ((this.__LocationStrategy_145 == null)) { (this.__LocationStrategy_145 = import32.provideLocationStrategy(this.parent.get(import6.PlatformLocation),this._APP_BASE_HREF_137,this._Config_36)); }
    return this.__LocationStrategy_145;
  }
  get _Location_146():import6.Location {
    if ((this.__Location_146 == null)) { (this.__Location_146 = new import6.Location(this._LocationStrategy_145)); }
    return this.__Location_146;
  }
  get _UrlSerializer_147():any {
    if ((this.__UrlSerializer_147 == null)) { (this.__UrlSerializer_147 = import157.setupUrlSerializer(this._App_39,this._DeepLinkConfigToken_41)); }
    return this.__UrlSerializer_147;
  }
  get _DeepLinker_148():any {
    if ((this.__DeepLinker_148 == null)) { (this.__DeepLinker_148 = import158.setupDeepLinker(this._App_39,this._UrlSerializer_147,this._Location_146,this._ModuleLoader_44,this.componentFactoryResolver)); }
    return this.__DeepLinker_148;
  }
  get _ModalController_149():import88.ModalController {
    if ((this.__ModalController_149 == null)) { (this.__ModalController_149 = new import88.ModalController(this._App_39,this._Config_36,this._DeepLinker_148)); }
    return this.__ModalController_149;
  }
  get _PickerController_150():import89.PickerController {
    if ((this.__PickerController_150 == null)) { (this.__PickerController_150 = new import89.PickerController(this._App_39,this._Config_36)); }
    return this.__PickerController_150;
  }
  get _PopoverController_151():import90.PopoverController {
    if ((this.__PopoverController_151 == null)) { (this.__PopoverController_151 = new import90.PopoverController(this._App_39,this._Config_36,this._DeepLinker_148)); }
    return this.__PopoverController_151;
  }
  get _TapClick_152():import91.TapClick {
    if ((this.__TapClick_152 == null)) { (this.__TapClick_152 = new import91.TapClick(this._Config_36,this._Platform_35,this._DomController_37,this._App_39,this._GestureController_40)); }
    return this.__TapClick_152;
  }
  get _ToastController_153():import92.ToastController {
    if ((this.__ToastController_153 == null)) { (this.__ToastController_153 = new import92.ToastController(this._App_39,this._Config_36)); }
    return this.__ToastController_153;
  }
  get _TransitionController_154():import93.TransitionController {
    if ((this.__TransitionController_154 == null)) { (this.__TransitionController_154 = new import93.TransitionController(this._Platform_35,this._Config_36)); }
    return this.__TransitionController_154;
  }
  get _ReportService_156():import94.ReportService {
    if ((this.__ReportService_156 == null)) { (this.__ReportService_156 = new import94.ReportService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16)); }
    return this.__ReportService_156;
  }
  get _EntityModel_157():any {
    if ((this.__EntityModel_157 == null)) { (this.__EntityModel_157 = this._OrderTransferTargetEntityModel_105); }
    return this.__EntityModel_157;
  }
  get _DataResourceModel_158():any {
    if ((this.__DataResourceModel_158 == null)) { (this.__DataResourceModel_158 = this._OrderTransferTargetEntityModel_105); }
    return this.__DataResourceModel_158;
  }
  get _SearchModel_159():any {
    if ((this.__SearchModel_159 == null)) { (this.__SearchModel_159 = this._StoreSearchModel_77); }
    return this.__SearchModel_159;
  }
  get _AbstractSearchModel_160():any {
    if ((this.__AbstractSearchModel_160 == null)) { (this.__AbstractSearchModel_160 = this._StoreSearchModel_77); }
    return this.__AbstractSearchModel_160;
  }
  get _AppAvailability_161():import95.AppAvailability {
    if ((this.__AppAvailability_161 == null)) { (this.__AppAvailability_161 = new import95.AppAvailability()); }
    return this.__AppAvailability_161;
  }
  get _ImageService_162():import96.ImageService {
    if ((this.__ImageService_162 == null)) { (this.__ImageService_162 = new import96.ImageService(this._JwtHttpClientService_25)); }
    return this.__ImageService_162;
  }
  get _CachedImageService_163():import97.CachedImageService {
    if ((this.__CachedImageService_163 == null)) { (this.__CachedImageService_163 = new import97.CachedImageService(this._JwtHttpClientService_25,this._ImageService_162)); }
    return this.__CachedImageService_163;
  }
  get _NativeWaiterAppService_164():import98.NativeWaiterAppService {
    if ((this.__NativeWaiterAppService_164 == null)) { (this.__NativeWaiterAppService_164 = new import98.NativeWaiterAppService()); }
    return this.__NativeWaiterAppService_164;
  }
  get _CardScanService_165():import99.CardScanService {
    if ((this.__CardScanService_165 == null)) { (this.__CardScanService_165 = new import99.CardScanService(this._NativeWaiterAppService_164)); }
    return this.__CardScanService_165;
  }
  get _Geolocation_166():import100.Geolocation {
    if ((this.__Geolocation_166 == null)) { (this.__Geolocation_166 = new import100.Geolocation()); }
    return this.__Geolocation_166;
  }
  get _IntegratedDeliveryAddressValidationService_167():import101.IntegratedDeliveryAddressValidationService {
    if ((this.__IntegratedDeliveryAddressValidationService_167 == null)) { (this.__IntegratedDeliveryAddressValidationService_167 = new import101.IntegratedDeliveryAddressValidationService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19)); }
    return this.__IntegratedDeliveryAddressValidationService_167;
  }
  get _SplashScreen_168():import102.SplashScreen {
    if ((this.__SplashScreen_168 == null)) { (this.__SplashScreen_168 = new import102.SplashScreen()); }
    return this.__SplashScreen_168;
  }
  get _StatusBar_169():import103.StatusBar {
    if ((this.__StatusBar_169 == null)) { (this.__StatusBar_169 = new import103.StatusBar()); }
    return this.__StatusBar_169;
  }
  get _ThemeModel_170():import104.ThemeModel {
    if ((this.__ThemeModel_170 == null)) { (this.__ThemeModel_170 = new import104.ThemeModel(this._SessionModel_74,this._AnalyticsService_67,this._ResponsiveService_65,this._TranslateService_30)); }
    return this.__ThemeModel_170;
  }
  createInternal():import1.AppModule {
    this._HttpModule_0 = new import2.HttpModule();
    this._ɵba_1 = new import3.ɵba();
    this._FormsModule_2 = new import3.FormsModule();
    this._InlineSVGModule_3 = new import4.InlineSVGModule();
    this._QRCodeModule_4 = new import5.QRCodeModule();
    this._CommonModule_5 = new import6.CommonModule();
    this._BrowserXhr_6 = new import2.BrowserXhr();
    this._ResponseOptions_7 = new import2.BaseResponseOptions();
    this._XSRFStrategy_8 = import2.ɵb();
    this._XHRBackend_9 = new import2.XHRBackend(this._BrowserXhr_6,this._ResponseOptions_7,this._XSRFStrategy_8);
    this._RequestOptions_10 = new import2.BaseRequestOptions();
    this._Http_11 = import2.ɵc(this._XHRBackend_9,this._RequestOptions_10);
    this._ConfigurationServiceConstants_12 = 'woa';
    this._ConfigurationServiceConstants_13 = 'assets/appconfig.json';
    this._ConfigurationServiceConstants_14 = [
      'userId',
      'webTerminalId',
      'outletId',
      'application'
    ]
    ;
    this._LocalConfigurationService_15 = new import7.LocalConfigurationService(this._Http_11,this._ConfigurationServiceConstants_12,this._ConfigurationServiceConstants_13,this._ConfigurationServiceConstants_14);
    this._ResourceModule_16 = 'wo';
    this._ResourceModule_17 = [
      'app',
      'identity',
      'menu',
      'device-token',
      'entitlement',
      'member-summary',
      'web-order-payment-details',
      'order-transfer-target'
    ]
    ;
    this._ResourceModule_18 = [
      'identity',
      'member-sales',
      'sellable-sizes',
      'store',
      'beacon',
      'active-schedules',
      'order-transfer-target'
    ]
    ;
    this._ResourceModule_19 = [
      'active-entitlement-validation',
      'app-entry-notification',
      'app-feedback',
      'identity-change-password',
      'identity-request-password-reset',
      'identity-reset-password',
      'available-order-times',
      'loyalty-card-redeem',
      'integrated-delivery-address-validation',
      'invoice-email-request',
      'web-order-initiation',
      'web-order-transfer',
      'web-order-transfer-request-poll',
      'web-order-placement-status',
      'web-order-placement',
      'web-order-postscript',
      'web-pending-orders'
    ]
    ;
    this._AuthService_20 = 10000;
    this._AuthService_21 = new import8.AuthService(this._Http_11,this._LocalConfigurationService_15,this._ResourceModule_16,this._ResourceModule_17,this._ResourceModule_18,this._ResourceModule_19,this._AuthService_20);
    this._MODULE_VERSIONS_22 = [
      {
        'module': 'data-client-api',
        'version': '2'
      }
      ,
      {
        module: 'web-order-app',
        version: '0.0.0'
      }

    ]
    ;
    this._VersionService_23 = new import9.VersionService(this._MODULE_VERSIONS_22);
    this._JwtHttpClientService_24 = 20000;
    this._JwtHttpClientService_25 = new import10.JwtHttpClientService(this._Http_11,this._AuthService_21,this._VersionService_23,this._JwtHttpClientService_24);
    this._I18nService_26 = new import11.I18nService(this._JwtHttpClientService_25,this);
    this._TranslateLoader_27 = import1.translateLoaderFactory(this._I18nService_26,this._Http_11);
    this._TranslateParser_28 = new import11.I18nService(this._JwtHttpClientService_25,this);
    this._MissingTranslationHandler_29 = new import11.I18nService(this._JwtHttpClientService_25,this);
    this._TranslateService_30 = new import12.TranslateService(this._TranslateLoader_27,this._TranslateParser_28,this._MissingTranslationHandler_29);
    this._ErrorService_31 = new import13.ErrorService(this._TranslateService_30);
    this._ErrorHandler_32 = new import14.GlobalErrorHandler(this._ErrorService_31);
    this._ConfigToken_33 = {animate: false};
    this._PlatformConfigToken_34 = import159.providePlatformConfigs();
    this._Platform_35 = import160.setupPlatform(this.parent.get(import23.DOCUMENT),this._PlatformConfigToken_34,this.parent.get(import0.NgZone));
    this._Config_36 = import161.setupConfig(this._ConfigToken_33,this._Platform_35);
    this._DomController_37 = new import15.DomController(this._Platform_35);
    this._MenuController_38 = new import16.MenuController();
    this._App_39 = new import17.App(this._Config_36,this._Platform_35,this._MenuController_38);
    this._GestureController_40 = new import18.GestureController(this._App_39);
    this._DeepLinkConfigToken_41 = {links: ([] as any[])};
    this._Compiler_42 = new import0.Compiler();
    this._NgModuleLoader_43 = new import19.NgModuleLoader(this._Compiler_42);
    this._ModuleLoader_44 = import162.provideModuleLoader(this._NgModuleLoader_43,this);
    this._BeaconSearchModel_45 = new import20.BeaconSearchModel(this);
    this._Device_46 = new import21.Device();
    this._ParamConfigService_47 = new import22.ParamConfigService(this._BeaconSearchModel_45,this._AuthService_21,this._LocalConfigurationService_15,this._Device_46);
    this._APP_INITIALIZER_48 = [
      import0.ɵo,
      import23.ɵc(this.parent.get(import23.NgProbeToken,(null as any)),this.parent.get(import0.NgProbeToken,(null as any))),
      import163.registerModeConfigs(this._Config_36),
      import83.setupProvideEvents(this._Platform_35,this._DomController_37),
      import91.setupTapClick(this._Config_36,this._Platform_35,this._DomController_37,this._App_39,this._GestureController_40),
      import162.setupPreloading(this._Config_36,this._DeepLinkConfigToken_41,this._ModuleLoader_44,this.parent.get(import0.NgZone)),
      import22.initParamConfigService(this._ParamConfigService_47)
    ]
    ;
    this._ApplicationInitStatus_49 = new import0.ApplicationInitStatus(this._APP_INITIALIZER_48);
    this._ɵf_50 = new import0.ɵf(this.parent.get(import0.NgZone),this.parent.get(import0.ɵConsole),this,this._ErrorHandler_32,this.componentFactoryResolver,this._ApplicationInitStatus_49);
    this._ApplicationRef_51 = this._ɵf_50;
    this._ApplicationModule_52 = new import0.ApplicationModule(this._ApplicationRef_51);
    this._BrowserModule_53 = new import23.BrowserModule(this.parent.get(import23.BrowserModule,(null as any)));
    this._BrowserAnimationsModule_54 = new import24.BrowserAnimationsModule();
    this._TranslateModule_55 = new import25.TranslateModule();
    this._AuthModule_56 = new import26.AuthModule(this.parent.get(import26.AuthModule,(null as any)));
    this._FedeltaHttpModule_57 = new import27.FedeltaHttpModule(this.parent.get(import27.FedeltaHttpModule,(null as any)));
    this._ConfigurationModule_58 = new import28.ConfigurationModule(this.parent.get(import28.ConfigurationModule,(null as any)));
    this._ErrorModule_59 = new import29.ErrorModule(this.parent.get(import29.ErrorModule,(null as any)));
    this._ValidationModule_60 = new import30.ValidationModule(this.parent.get(import30.ValidationModule,(null as any)));
    this._I18nModule_61 = new import31.I18nModule(this.parent.get(import31.I18nModule,(null as any)));
    this._ReactiveFormsModule_62 = new import3.ReactiveFormsModule();
    this._IonicModule_63 = new import32.IonicModule();
    this._ResourceModule_64 = new import33.ResourceModule(this.parent.get(import33.ResourceModule,(null as any)));
    this._ResponsiveService_65 = new import34.ResponsiveService(this._ApplicationRef_51,this._LocalConfigurationService_15,this._Platform_35);
    this._NavigationService_66 = new import35.NavigationService(this,this._ResponsiveService_65,this.componentFactoryResolver,this._Platform_35);
    this._AnalyticsService_67 = new import36.AnalyticsService(this._LocalConfigurationService_15,this._ResponsiveService_65,this._ParamConfigService_47);
    this._AppEntityModel_68 = new import37.AppEntityModel(this);
    this._ServerLoggingService_69 = new import38.ServerLoggingService(this._JwtHttpClientService_25,this._AuthService_21,this._ConfigurationServiceConstants_12);
    this._NotificationService_70 = new import39.NotificationService(this,this._ErrorService_31,this._ServerLoggingService_69,this._NavigationService_66);
    this._AppSessionService_71 = new import40.AppSessionService();
    this._ConfigurationService_72 = new import41.ConfigurationService(this._JwtHttpClientService_25,this._Http_11,this._AuthService_21,this._ConfigurationServiceConstants_12,this._ConfigurationServiceConstants_13,this._ConfigurationServiceConstants_14);
    this._AppEntryNotificationService_73 = new import42.AppEntryNotificationService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19);
    this._SessionModel_74 = new import43.SessionModel(this._AppEntityModel_68,this._NavigationService_66,this._NotificationService_70,this._LocalConfigurationService_15,this._ResponsiveService_65,this._TranslateService_30,this._ParamConfigService_47,this._AppSessionService_71,this._AppEntryNotificationService_73);
    this._MemberSummaryEntityModel_75 = new import44.MemberSummaryEntityModel(this);
    this._STORE_SEARCH_FILTER_PROVIDER_76 = new import45.OrderingContextStoreSearchFilterProvider();
    this._StoreSearchModel_77 = new import46.StoreSearchModel(this,this._STORE_SEARCH_FILTER_PROVIDER_76);
    this._ActiveSchedulesSearchModel_78 = new import47.ActiveSchedulesSearchModel(this);
    this._LoadingService_79 = new import48.LoadingService(this._TranslateService_30);
    this._CustomerDetailsService_80 = new import49.CustomerDetailsService(this._SessionModel_74);
    this._GeolocateService_81 = new import50.GeolocateService(this._ResponsiveService_65);
    this._OrderingContextModel_82 = new import45.OrderingContextModel(this._SessionModel_74,this._StoreSearchModel_77,this._ActiveSchedulesSearchModel_78,this._NavigationService_66,this._ParamConfigService_47,this._NotificationService_70,this._ResponsiveService_65,this._LoadingService_79,this._TranslateService_30,this._AuthService_21,this._CustomerDetailsService_80,this._GeolocateService_81,this._AnalyticsService_67);
    this._IdentityModel_83 = new import51.IdentityModel(this._AuthService_21,this._MemberSummaryEntityModel_75,this._SessionModel_74,this._OrderingContextModel_82,this._Device_46,this._NotificationService_70,this._ConfigurationService_72,this._LocalConfigurationService_15,this._ResponsiveService_65,this._NavigationService_66);
    this._PendingOrdersService_84 = new import52.PendingOrdersService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19);
    this._PromoModel_85 = new import53.PromoModel(this._SessionModel_74,this._OrderingContextModel_82,this._IdentityModel_83,this._TranslateService_30);
    this._MenuEntityModel_86 = new import54.MenuEntityModel(this);
    this._SellableSizesSearchModel_87 = new import55.SellableSizesSearchModel(this);
    this._MenuModel_88 = new import56.MenuModel(this._SessionModel_74,this._ResponsiveService_65,this._OrderingContextModel_82,this._ActiveSchedulesSearchModel_78,this._PromoModel_85,this._IdentityModel_83,this._MenuEntityModel_86,this._SellableSizesSearchModel_87);
    this._ActiveEntitlementValidationService_89 = new import57.ActiveEntitlementValidationService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19);
    this._LoyaltyCardRedemptionService_90 = new import58.LoyaltyCardRedemptionService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19);
    this._EntitlementEntityModel_91 = new import59.EntitlementEntityModel(this);
    this._DealModel_92 = new import60.DealModel(this._ActiveEntitlementValidationService_89,this._LoyaltyCardRedemptionService_90,this._EntitlementEntityModel_91,this._MenuModel_88,this._SessionModel_74,this._OrderingContextModel_82,this._IdentityModel_83,this._TranslateService_30,this._NotificationService_70);
    this._OrderPaymentDetailsEntityModel_93 = new import61.OrderPaymentDetailsEntityModel(this);
    this._PaymentModel_94 = new import62.PaymentModel(this._NavigationService_66,this._AnalyticsService_67,this._ParamConfigService_47,this._ResponsiveService_65,this._LoadingService_79,this._SessionModel_74,this._OrderingContextModel_82,this._OrderPaymentDetailsEntityModel_93,this._CustomerDetailsService_80,this._NotificationService_70);
    this._RecentOrderService_95 = new import63.RecentOrderService(this._AuthService_21,this._OrderingContextModel_82);
    this._OrderInitiationService_96 = new import64.OrderInitiationService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19);
    this._OrderPlacementService_97 = new import65.OrderPlacementService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19);
    this._OrderPlacementStatusService_98 = new import66.OrderPlacementStatusService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19);
    this._OrderPostscriptService_99 = new import67.OrderPostscriptService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19);
    this._OrderTransferService_100 = new import68.OrderTransferService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19);
    this._OrderTransferRequestPollService_101 = new import69.OrderTransferRequestPollService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19);
    this._AvailableOrderTimesService_102 = new import70.AvailableOrderTimesService(this._JwtHttpClientService_25,this._ConfigurationService_72,this._ResourceModule_16,this._ResourceModule_19);
    this._AppUserService_103 = new import71.AppUserService();
    this._OrderModel_104 = new import72.OrderModel(this._SessionModel_74,this._IdentityModel_83,this._OrderingContextModel_82,this._PendingOrdersService_84,this._MenuModel_88,this._DealModel_92,this._PaymentModel_94,this._RecentOrderService_95,this._OrderInitiationService_96,this._OrderPlacementService_97,this._OrderPlacementStatusService_98,this._OrderPostscriptService_99,this._OrderTransferService_100,this._OrderTransferRequestPollService_101,this._AvailableOrderTimesService_102,this._ActiveSchedulesSearchModel_78,this._CustomerDetailsService_80,this._AppUserService_103,this._NotificationService_70,this._NavigationService_66,this._LoadingService_79,this._AnalyticsService_67,this._ResponsiveService_65);
    this._OrderTransferTargetEntityModel_105 = new import73.OrderTransferTargetEntityModel(this);
    this._OrderTransferTargetSearchModel_106 = new import74.OrderTransferTargetSearchModel(this);
    this._GroupOrderModel_107 = new import75.GroupOrderModel(this._SessionModel_74,this._OrderingContextModel_82,this._OrderModel_104,this._IdentityModel_83,this._ActiveSchedulesSearchModel_78,this._OrderTransferTargetEntityModel_105,this._OrderTransferTargetSearchModel_106,this._LoadingService_79,this._NavigationService_66);
    this._OrderingContextController_108 = new import76.OrderingContextController(this._SessionModel_74,this._OrderingContextModel_82,this._OrderModel_104,this._NotificationService_70,this._LoadingService_79,this._NavigationService_66);
    this._SessionController_109 = new import77.SessionController(this._AnalyticsService_67,this._Platform_35,this._SessionModel_74,this._OrderingContextModel_82,this._OrderingContextController_108,this._RecentOrderService_95,this._ResponsiveService_65,this._NotificationService_70,this._NavigationService_66);
    this._AppModule_110 = new import1.AppModule(this._LocalConfigurationService_15,this._ParamConfigService_47,this._NavigationService_66,this._AnalyticsService_67,this._SessionModel_74,this._OrderModel_104,this._GroupOrderModel_107,this._MenuModel_88,this._PaymentModel_94,this._PromoModel_85,this._DealModel_92,this._IdentityModel_83,this._OrderingContextModel_82,this._OrderingContextController_108,this._SessionController_109,this._STORE_SEARCH_FILTER_PROVIDER_76);
    this._ValidationService_134 = 'woa';
    this._AppRootToken_136 = import164.MyApp;
    this._APP_BASE_HREF_137 = '/';
    this._ResourceModule_155 = (undefined as any);
    return this._AppModule_110;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.HttpModule)) { return this._HttpModule_0; }
    if ((token === import3.ɵba)) { return this._ɵba_1; }
    if ((token === import3.FormsModule)) { return this._FormsModule_2; }
    if ((token === import4.InlineSVGModule)) { return this._InlineSVGModule_3; }
    if ((token === import5.QRCodeModule)) { return this._QRCodeModule_4; }
    if ((token === import6.CommonModule)) { return this._CommonModule_5; }
    if ((token === import2.BrowserXhr)) { return this._BrowserXhr_6; }
    if ((token === import2.ResponseOptions)) { return this._ResponseOptions_7; }
    if ((token === import2.XSRFStrategy)) { return this._XSRFStrategy_8; }
    if ((token === import2.XHRBackend)) { return this._XHRBackend_9; }
    if ((token === import2.RequestOptions)) { return this._RequestOptions_10; }
    if ((token === import2.Http)) { return this._Http_11; }
    if ((token === import165.ConfigurationServiceConstants.APPLICATION_KEY)) { return this._ConfigurationServiceConstants_12; }
    if ((token === import165.ConfigurationServiceConstants.LOCAL_CONFIG_FILE_KEY)) { return this._ConfigurationServiceConstants_13; }
    if ((token === import165.ConfigurationServiceConstants.CONTEXT_NAMES_KEY)) { return this._ConfigurationServiceConstants_14; }
    if ((token === import7.LocalConfigurationService)) { return this._LocalConfigurationService_15; }
    if ((token === import33.ResourceModule.RESOURCE_NAMESPACE_KEY)) { return this._ResourceModule_16; }
    if ((token === import33.ResourceModule.ENTITY_NAMES_KEY)) { return this._ResourceModule_17; }
    if ((token === import33.ResourceModule.SEARCH_NAMES_KEY)) { return this._ResourceModule_18; }
    if ((token === import33.ResourceModule.ACTION_NAMES_KEY)) { return this._ResourceModule_19; }
    if ((token === import8.AuthService.HTTP_TIMEOUT_KEY)) { return this._AuthService_20; }
    if ((token === import8.AuthService)) { return this._AuthService_21; }
    if ((token === import166.MODULE_VERSIONS)) { return this._MODULE_VERSIONS_22; }
    if ((token === import9.VersionService)) { return this._VersionService_23; }
    if ((token === import10.JwtHttpClientService.HTTP_TIMEOUT_KEY)) { return this._JwtHttpClientService_24; }
    if ((token === import10.JwtHttpClientService)) { return this._JwtHttpClientService_25; }
    if ((token === import11.I18nService)) { return this._I18nService_26; }
    if ((token === import12.TranslateLoader)) { return this._TranslateLoader_27; }
    if ((token === import167.TranslateParser)) { return this._TranslateParser_28; }
    if ((token === import12.MissingTranslationHandler)) { return this._MissingTranslationHandler_29; }
    if ((token === import12.TranslateService)) { return this._TranslateService_30; }
    if ((token === import13.ErrorService)) { return this._ErrorService_31; }
    if ((token === import0.ErrorHandler)) { return this._ErrorHandler_32; }
    if ((token === import161.ConfigToken)) { return this._ConfigToken_33; }
    if ((token === import159.PlatformConfigToken)) { return this._PlatformConfigToken_34; }
    if ((token === import160.Platform)) { return this._Platform_35; }
    if ((token === import161.Config)) { return this._Config_36; }
    if ((token === import15.DomController)) { return this._DomController_37; }
    if ((token === import16.MenuController)) { return this._MenuController_38; }
    if ((token === import17.App)) { return this._App_39; }
    if ((token === import18.GestureController)) { return this._GestureController_40; }
    if ((token === import157.DeepLinkConfigToken)) { return this._DeepLinkConfigToken_41; }
    if ((token === import0.Compiler)) { return this._Compiler_42; }
    if ((token === import19.NgModuleLoader)) { return this._NgModuleLoader_43; }
    if ((token === import162.ModuleLoader)) { return this._ModuleLoader_44; }
    if ((token === import20.BeaconSearchModel)) { return this._BeaconSearchModel_45; }
    if ((token === import21.Device)) { return this._Device_46; }
    if ((token === import22.ParamConfigService)) { return this._ParamConfigService_47; }
    if ((token === import0.APP_INITIALIZER)) { return this._APP_INITIALIZER_48; }
    if ((token === import0.ApplicationInitStatus)) { return this._ApplicationInitStatus_49; }
    if ((token === import0.ɵf)) { return this._ɵf_50; }
    if ((token === import0.ApplicationRef)) { return this._ApplicationRef_51; }
    if ((token === import0.ApplicationModule)) { return this._ApplicationModule_52; }
    if ((token === import23.BrowserModule)) { return this._BrowserModule_53; }
    if ((token === import24.BrowserAnimationsModule)) { return this._BrowserAnimationsModule_54; }
    if ((token === import25.TranslateModule)) { return this._TranslateModule_55; }
    if ((token === import26.AuthModule)) { return this._AuthModule_56; }
    if ((token === import27.FedeltaHttpModule)) { return this._FedeltaHttpModule_57; }
    if ((token === import28.ConfigurationModule)) { return this._ConfigurationModule_58; }
    if ((token === import29.ErrorModule)) { return this._ErrorModule_59; }
    if ((token === import30.ValidationModule)) { return this._ValidationModule_60; }
    if ((token === import31.I18nModule)) { return this._I18nModule_61; }
    if ((token === import3.ReactiveFormsModule)) { return this._ReactiveFormsModule_62; }
    if ((token === import32.IonicModule)) { return this._IonicModule_63; }
    if ((token === import33.ResourceModule)) { return this._ResourceModule_64; }
    if ((token === import34.ResponsiveService)) { return this._ResponsiveService_65; }
    if ((token === import35.NavigationService)) { return this._NavigationService_66; }
    if ((token === import36.AnalyticsService)) { return this._AnalyticsService_67; }
    if ((token === import37.AppEntityModel)) { return this._AppEntityModel_68; }
    if ((token === import38.ServerLoggingService)) { return this._ServerLoggingService_69; }
    if ((token === import39.NotificationService)) { return this._NotificationService_70; }
    if ((token === import40.AppSessionService)) { return this._AppSessionService_71; }
    if ((token === import41.ConfigurationService)) { return this._ConfigurationService_72; }
    if ((token === import42.AppEntryNotificationService)) { return this._AppEntryNotificationService_73; }
    if ((token === import43.SessionModel)) { return this._SessionModel_74; }
    if ((token === import44.MemberSummaryEntityModel)) { return this._MemberSummaryEntityModel_75; }
    if ((token === import46.STORE_SEARCH_FILTER_PROVIDER)) { return this._STORE_SEARCH_FILTER_PROVIDER_76; }
    if ((token === import46.StoreSearchModel)) { return this._StoreSearchModel_77; }
    if ((token === import47.ActiveSchedulesSearchModel)) { return this._ActiveSchedulesSearchModel_78; }
    if ((token === import48.LoadingService)) { return this._LoadingService_79; }
    if ((token === import49.CustomerDetailsService)) { return this._CustomerDetailsService_80; }
    if ((token === import50.GeolocateService)) { return this._GeolocateService_81; }
    if ((token === import45.OrderingContextModel)) { return this._OrderingContextModel_82; }
    if ((token === import51.IdentityModel)) { return this._IdentityModel_83; }
    if ((token === import52.PendingOrdersService)) { return this._PendingOrdersService_84; }
    if ((token === import53.PromoModel)) { return this._PromoModel_85; }
    if ((token === import54.MenuEntityModel)) { return this._MenuEntityModel_86; }
    if ((token === import55.SellableSizesSearchModel)) { return this._SellableSizesSearchModel_87; }
    if ((token === import56.MenuModel)) { return this._MenuModel_88; }
    if ((token === import57.ActiveEntitlementValidationService)) { return this._ActiveEntitlementValidationService_89; }
    if ((token === import58.LoyaltyCardRedemptionService)) { return this._LoyaltyCardRedemptionService_90; }
    if ((token === import59.EntitlementEntityModel)) { return this._EntitlementEntityModel_91; }
    if ((token === import60.DealModel)) { return this._DealModel_92; }
    if ((token === import61.OrderPaymentDetailsEntityModel)) { return this._OrderPaymentDetailsEntityModel_93; }
    if ((token === import62.PaymentModel)) { return this._PaymentModel_94; }
    if ((token === import63.RecentOrderService)) { return this._RecentOrderService_95; }
    if ((token === import64.OrderInitiationService)) { return this._OrderInitiationService_96; }
    if ((token === import65.OrderPlacementService)) { return this._OrderPlacementService_97; }
    if ((token === import66.OrderPlacementStatusService)) { return this._OrderPlacementStatusService_98; }
    if ((token === import67.OrderPostscriptService)) { return this._OrderPostscriptService_99; }
    if ((token === import68.OrderTransferService)) { return this._OrderTransferService_100; }
    if ((token === import69.OrderTransferRequestPollService)) { return this._OrderTransferRequestPollService_101; }
    if ((token === import70.AvailableOrderTimesService)) { return this._AvailableOrderTimesService_102; }
    if ((token === import71.AppUserService)) { return this._AppUserService_103; }
    if ((token === import72.OrderModel)) { return this._OrderModel_104; }
    if ((token === import73.OrderTransferTargetEntityModel)) { return this._OrderTransferTargetEntityModel_105; }
    if ((token === import74.OrderTransferTargetSearchModel)) { return this._OrderTransferTargetSearchModel_106; }
    if ((token === import75.GroupOrderModel)) { return this._GroupOrderModel_107; }
    if ((token === import76.OrderingContextController)) { return this._OrderingContextController_108; }
    if ((token === import77.SessionController)) { return this._SessionController_109; }
    if ((token === import1.AppModule)) { return this._AppModule_110; }
    if ((token === import3.ɵi)) { return this._ɵi_111; }
    if ((token === import78.SVGCacheService)) { return this._SVGCacheService_112; }
    if ((token === import0.LOCALE_ID)) { return this._LOCALE_ID_113; }
    if ((token === import6.NgLocalization)) { return this._NgLocalization_114; }
    if ((token === import0.APP_ID)) { return this._APP_ID_115; }
    if ((token === import0.IterableDiffers)) { return this._IterableDiffers_116; }
    if ((token === import0.KeyValueDiffers)) { return this._KeyValueDiffers_117; }
    if ((token === import23.DomSanitizer)) { return this._DomSanitizer_118; }
    if ((token === import0.Sanitizer)) { return this._Sanitizer_119; }
    if ((token === import23.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_120; }
    if ((token === import23.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_121; }
    if ((token === import23.EventManager)) { return this._EventManager_122; }
    if ((token === import23.ɵDomSharedStylesHost)) { return this._ɵDomSharedStylesHost_123; }
    if ((token === import23.ɵDomRendererFactory2)) { return this._ɵDomRendererFactory2_124; }
    if ((token === import168.AnimationDriver)) { return this._AnimationDriver_125; }
    if ((token === import168.ɵAnimationStyleNormalizer)) { return this._ɵAnimationStyleNormalizer_126; }
    if ((token === import168.ɵAnimationEngine)) { return this._ɵAnimationEngine_127; }
    if ((token === import0.RendererFactory2)) { return this._RendererFactory2_128; }
    if ((token === import23.ɵSharedStylesHost)) { return this._ɵSharedStylesHost_129; }
    if ((token === import0.Testability)) { return this._Testability_130; }
    if ((token === import23.Meta)) { return this._Meta_131; }
    if ((token === import23.Title)) { return this._Title_132; }
    if ((token === import3.FormBuilder)) { return this._FormBuilder_133; }
    if ((token === import80.ValidationService.APPLICATION_KEY)) { return this._ValidationService_134; }
    if ((token === import80.ValidationService)) { return this._ValidationService_135; }
    if ((token === import169.AppRootToken)) { return this._AppRootToken_136; }
    if ((token === import6.APP_BASE_HREF)) { return this._APP_BASE_HREF_137; }
    if ((token === import81.ActionSheetController)) { return this._ActionSheetController_138; }
    if ((token === import82.AlertController)) { return this._AlertController_139; }
    if ((token === import83.Events)) { return this._Events_140; }
    if ((token === import84.Form)) { return this._Form_141; }
    if ((token === import85.Haptic)) { return this._Haptic_142; }
    if ((token === import86.Keyboard)) { return this._Keyboard_143; }
    if ((token === import87.LoadingController)) { return this._LoadingController_144; }
    if ((token === import6.LocationStrategy)) { return this._LocationStrategy_145; }
    if ((token === import6.Location)) { return this._Location_146; }
    if ((token === import157.UrlSerializer)) { return this._UrlSerializer_147; }
    if ((token === import158.DeepLinker)) { return this._DeepLinker_148; }
    if ((token === import88.ModalController)) { return this._ModalController_149; }
    if ((token === import89.PickerController)) { return this._PickerController_150; }
    if ((token === import90.PopoverController)) { return this._PopoverController_151; }
    if ((token === import91.TapClick)) { return this._TapClick_152; }
    if ((token === import92.ToastController)) { return this._ToastController_153; }
    if ((token === import93.TransitionController)) { return this._TransitionController_154; }
    if ((token === import33.ResourceModule.RESOURCE_USE_ASYNC)) { return this._ResourceModule_155; }
    if ((token === import94.ReportService)) { return this._ReportService_156; }
    if ((token === import170.EntityModel)) { return this._EntityModel_157; }
    if ((token === import171.DataResourceModel)) { return this._DataResourceModel_158; }
    if ((token === import172.SearchModel)) { return this._SearchModel_159; }
    if ((token === import173.AbstractSearchModel)) { return this._AbstractSearchModel_160; }
    if ((token === import95.AppAvailability)) { return this._AppAvailability_161; }
    if ((token === import96.ImageService)) { return this._ImageService_162; }
    if ((token === import97.CachedImageService)) { return this._CachedImageService_163; }
    if ((token === import98.NativeWaiterAppService)) { return this._NativeWaiterAppService_164; }
    if ((token === import99.CardScanService)) { return this._CardScanService_165; }
    if ((token === import100.Geolocation)) { return this._Geolocation_166; }
    if ((token === import101.IntegratedDeliveryAddressValidationService)) { return this._IntegratedDeliveryAddressValidationService_167; }
    if ((token === import102.SplashScreen)) { return this._SplashScreen_168; }
    if ((token === import103.StatusBar)) { return this._StatusBar_169; }
    if ((token === import104.ThemeModel)) { return this._ThemeModel_170; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ɵf_50.ngOnDestroy();
    this._OrderingContextModel_82.ngOnDestroy();
    this._IdentityModel_83.ngOnDestroy();
    this._PromoModel_85.ngOnDestroy();
    this._MenuModel_88.ngOnDestroy();
    this._DealModel_92.ngOnDestroy();
    this._PaymentModel_94.ngOnDestroy();
    this._OrderModel_104.ngOnDestroy();
    this._GroupOrderModel_107.ngOnDestroy();
    this._SessionController_109.ngOnDestroy();
    (this.__ɵDomSharedStylesHost_123 && this._ɵDomSharedStylesHost_123.ngOnDestroy());
  }
}
export const AppModuleNgFactory:import0.NgModuleFactory<import1.AppModule> = new import0.NgModuleFactory<any>(AppModuleInjector,import1.AppModule);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/app/app.module.ngfactory.ts